/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveInvitedUsers_Mutation = { readonly __typename: 'Mutation', readonly removeInvitedUsers: ReadonlyArray<string | null> };


export type RemoveInvitedUsersVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
  emails: ReadonlyArray<_Types.InputMaybe<_Types.Scalars['String']['input']>> | _Types.InputMaybe<_Types.Scalars['String']['input']>;
}>;


export type RemoveInvitedUsers = RemoveInvitedUsers_Mutation;


export const RemoveInvitedUsersDocument = gql`
    mutation RemoveInvitedUsers($creditApplicationId: ID!, $emails: [String]!) {
  removeInvitedUsers(creditApplicationId: $creditApplicationId, emails: $emails)
}
    `;
export type RemoveInvitedUsersMutationFn = Apollo.MutationFunction<RemoveInvitedUsers, RemoveInvitedUsersVariables>;

/**
 * __useRemoveInvitedUsers__
 *
 * To run a mutation, you first call `useRemoveInvitedUsers` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveInvitedUsers` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeInvitedUsers, { data, loading, error }] = useRemoveInvitedUsers({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useRemoveInvitedUsers(baseOptions?: Apollo.MutationHookOptions<RemoveInvitedUsers, RemoveInvitedUsersVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveInvitedUsers, RemoveInvitedUsersVariables>(RemoveInvitedUsersDocument, options);
      }
export type RemoveInvitedUsersHookResult = ReturnType<typeof useRemoveInvitedUsers>;
export type RemoveInvitedUsersMutationResult = Apollo.MutationResult<RemoveInvitedUsers>;
export type RemoveInvitedUsersMutationOptions = Apollo.BaseMutationOptions<RemoveInvitedUsers, RemoveInvitedUsersVariables>;